export default () => ({
  isMenuOpened: {
    category: false,
    user: false,
  },
  activeMenuItem: {
    category: '',
    user: '',
  },
  categoryMenuData: [],
  mobileCategoryMenuData: [],
  autocompleteCategoryMenuData: null,
  userMenuData: [],
  headerPrefix: '',
  isMobileSearchOpened: false,
  isScrollDownMobileHide: false,
  isInitialMobileHideSearch: false,
  showLoader: false,
  showPageDarkLayer: false,
  ageInformationPopup: {
    show: false,
    addToCartInfo: null,
  },
});
